import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon/icon-to-top.png'


import { reactive, ref, onMounted, onUnmounted } from 'vue';
  import Concat, { ConcatStyle } from './concat.vue';
  import { isMobile } from '@/utils';
  import ButtonShoppingCart from './shopping-cart.vue';
  import { IS_KO_PRODUCTON } from '@/constants';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const concatLoaded = ref(false);
  const scrollTop = ref(0);
  const backUpStyle = reactive<ConcatStyle>({
    width: '4.5rem',
    height: '4.5rem',
    right: isMobile() ? '20px' : '4.5rem'
  });
  const handleBackUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  let timer = 0;
  onUnmounted(() => clearTimeout(timer));
  function cancatLoaded(style: ConcatStyle) {
    clearTimeout(timer);
    Object.assign(backUpStyle, style);
    concatLoaded.value = true;
  }

  function init() {
    window.addEventListener('scroll', () => {
      scrollTop.value = document.documentElement.scrollTop || document.body.scrollTop;
    });
  }

  // concat失败的情况
  timer = setTimeout(() => {
    concatLoaded.value = true;
    // 韩国prod环境先不加载bot按钮, concatLoaded = true才显示回到顶部按钮
  }, IS_KO_PRODUCTON ? 0 : 5000);


  onMounted(init);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "float-wrapper",
    style: _normalizeStyle([{ right: _unref(backUpStyle).right }])
  }, [
    (!_unref(IS_KO_PRODUCTON))
      ? (_openBlock(), _createBlock(Concat, {
          key: 0,
          onLoaded: cancatLoaded
        }))
      : _createCommentVNode("", true),
    (_ctx.$route.name === 'variant.detail')
      ? (_openBlock(), _createBlock(ButtonShoppingCart, {
          key: 1,
          class: "button-action",
          style: _normalizeStyle({ width: _unref(backUpStyle).width, height: _unref(backUpStyle).height })
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    (concatLoaded.value && scrollTop.value > 20)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "button-action pointer",
          style: _normalizeStyle({ width: _unref(backUpStyle).width, height: _unref(backUpStyle).height })
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            onClick: handleBackUp
          })
        ], 4))
      : _createCommentVNode("", true)
  ], 4))
}
}

})